// extracted by mini-css-extract-plugin
export default {"languageToggle":"LanguageToggle_languageToggle__Pe2U8"};